module.exports = __webpack_public_path__ + "img/icon3.247aff98.png";